// store.js
import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import AuthReducer from "./reducers/AuthReducer";
import BranchReducer from "./reducers/BranchReducer";
import CategoryReducer from "./reducers/CategoryReducer";
import DepartmentReducer from "./reducers/DepartmentReducer";
import DashboardReducer from "./reducers/DashboardCardReducer";
import SymptomReducer from "./reducers/SymptomReducer";
import DiseaseReducer from "./reducers/DiseasesReducer";
import MedicineReducer from "./reducers/MedicinesReducer";
import DoctorsReducer from "./reducers/DoctorsReducer";
import DiseaseMedicineMappingReducer from "./reducers/DiseaseMedicineMappingReducer";
import SymptomMedicineMappingReducer from "./reducers/SymptomMedicineMappingReducer";
import PatientReducer from "./reducers/PatientsReducer";
import AdminUserReducer from "./reducers/AdminUserReducer";
import ReceptionistReducer from "./reducers/ReceptionistReducer";
import NoteReducer from "./reducers/NotesReducer";
import PrescriptionReducer from "./reducers/PrescriptionReducer";
import QuestionnaireReducer from "./reducers/QuestionnaireReducer";
import ImportantQuestionsReducer from "./reducers/ImportantQuestionReducer";
import CounsellorReducer from "./reducers/CounsellorReducer";
import TokenSystemReducer from "./reducers/TokenSystemReducer";
import medicalReducer from "./reducers/medicalReducer";
import RoleReducer from "./reducers/RoleReducer";
import PatientMaleChartReducer from "./reducers/PatientMaleChartReducer";
import PatientGapldReducer from "./reducers/PatientGapldReducer";
import PatientMenopauseChartReducer from "./reducers/PatientMenopauseReducer";
import ImportLeadsReducer from "./reducers/importLeadReducer";
import LeadReducer from "./reducers/LeadReducer";
import LeadReducers from "./reducers/LeadReducers";
import ReportReducer from "./reducers/ReportReducer";
import FollowUpReducer from "./reducers/FollowUpReducer";
import AppointmentReducer from "./reducers/AppointmentReducer";
import questionnaireReducer from "./reducers/QuestionnaireReducer";
import LeadNotesReducer from "./reducers/LeadNoteReducer";
import ServiceCallerReducer from "./reducers/ServiceCallerReducer";
import prescriptionReducer from "./reducers/ServiceCallerPrescriptionReducer";
import DiseaseHistoryReducer from "./reducers/DiseaseHistoryReducer";
import settingReducer from "./reducers/SettingReducer";
import serviceFollowupReducer from "./reducers/ServiceFollowUpReducer";
import followUpReminderReducer from "./reducers/FollowUpReminderReducer";
import casePaperReducer from "./reducers/CasePaperReducer";
import profileReducer from "./reducers/AppProfileReducer";
import { toggleMenu } from "./reducers/AuthReducer";
import changePasswordReducer from "./reducers/ChangePasswordReducer";
import forgotPasswordReducer from "./reducers/AppForgetPasswordReducer";
import transactionReducer from "./reducers/TranscationHistoryReducer";
import ContentBankReducer from "./reducers/ContentBankReducer";
import TokenMultiSystemReducer from "./reducers/TokenMultiSystemReducer";
import ScriptReducer from "./reducers/ScriptReducer";
import Karma from "../jsx/components/Panchkarma/Karma";
import KarmaReducer from "./reducers/KarmaReducer";
import panchkarmaUserReducer from "./reducers/PanchkarmaReducer/UserReducer";

import UploadReportReducer from "./reducers/UploadReportReducer";
import MonthlyTargetReducer from "./reducers/MonthlyTargetReducer";
import PatientLmpReducer from "./reducers/PatientLmpReducer";
import PathyaReducer from "./reducers/PathyaReducer";
import MedicineTypeReducer from "./reducers/MedicineTypeReducer";
import FrequencyReducer from "./reducers/FrequencyReducer";
import ObjectionReducer from "./reducers/ObjectionReducer"
import NoteCategoryReducer from "./reducers/NoteCategoriesReducer";
import DefaultDoseReducer from "./reducers/DefaultDoseReducer"
import UnitOfDoseReducer from "./reducers/UnitOfDoseReducer"
import HowToTakeReducer from "./reducers/HowToTakeReducer";
import CampaignReducer from "./reducers/CampaignReducer";
import telecallerReducer from "./reducers/telecallerReducer";
import callReducer from "./reducers/callReducer";
import AssignedAppointmentReducer from "./reducers/AssignedAppointmentReducer";
import PatientCuredDiseasesReducer from "./reducers/PatientCuredDiseasesReducer";
import LeadHistoryReducer from "./reducers/LeadHistoryReducer";
import AnupanReducer from "./reducers/AnupanReducer";
import PatientReviewReducer from "./reducers/PatientReviewReducer";
import { AppoinmentReducer } from "./reducers/AppoinmentReducer";
import serviceCallerReassignmentReducer from "./reducers/ServiceCallerReassignmentReducer"
import printQRReducer from "./reducers/printQRReducer";
import inwardStockReducer from "./reducers/inwardStockReducer"
import stockTransactionReducer from "./reducers/stockTransactionReducer"
const rootReducer = combineReducers({
  sideMenu: toggleMenu,
  auth: AuthReducer,
  patients: PatientReducer,
  branches: BranchReducer,
  categories: CategoryReducer,
  department: DepartmentReducer,
  symptoms: SymptomReducer,
  diseases: DiseaseReducer,
  medicines: MedicineReducer,
  doctors: DoctorsReducer,
  adminUser: AdminUserReducer,
  panchkarmaUser: panchkarmaUserReducer,
  questionnaire: QuestionnaireReducer,
  questionnaireState: questionnaireReducer,
  diseaseMedicineMappings: DiseaseMedicineMappingReducer,
  symptomMedicineMappings: SymptomMedicineMappingReducer,
  receptionists: ReceptionistReducer,
  notes: NoteReducer,
  prescriptions: PrescriptionReducer,
  importantQuestions: ImportantQuestionsReducer,
  counsellor: CounsellorReducer,
  tokenSystem: TokenSystemReducer,
  medical: medicalReducer,
  role: RoleReducer,
  patientMaleChart: PatientMaleChartReducer,
  patientGapld: PatientGapldReducer,
  patientMenopause: PatientMenopauseChartReducer,
  importLeads: ImportLeadsReducer,
  leadState: LeadReducers, // for leads
  leads: LeadReducer,
  reports: ReportReducer,
  followUps: FollowUpReducer,
  leadNotes: LeadNotesReducer,
  serviceCaller: ServiceCallerReducer,
  prescriptionState: prescriptionReducer,
  appointmentState: AppointmentReducer,
  diseaseHistory: DiseaseHistoryReducer,
  setting: settingReducer,
  serviceFollowup: serviceFollowupReducer,
  followUpReminder: followUpReminderReducer,
  casePaper: casePaperReducer,
  profile: profileReducer,
  changePassword: changePasswordReducer,
  forgotPassword: forgotPasswordReducer,
  transaction: transactionReducer,
  contentBank: ContentBankReducer,
  script: ScriptReducer,
  tokenMultiSystem: TokenMultiSystemReducer,
  dashboard: DashboardReducer,
  karma:KarmaReducer,
  // api provisions
  medicineType: MedicineTypeReducer,
  frequency : FrequencyReducer,
  objection: ObjectionReducer, 
  noteCategory: NoteCategoryReducer,
  pathya: PathyaReducer,
  defaultDose: DefaultDoseReducer,
  unitDose:UnitOfDoseReducer,
  howToTake: HowToTakeReducer,
  campaign: CampaignReducer, 
  telecaller: telecallerReducer,
  call: callReducer, 
  assignedAppointments: AssignedAppointmentReducer,
  patientCuredDiseases: PatientCuredDiseasesReducer,
  // uploadReport: UploadReportReducer,
  monthlyTarget: MonthlyTargetReducer,
  // patientLmp: PatientLmpReducer,
  leadHistory: LeadHistoryReducer,
  anupan: AnupanReducer,
  patientReview: PatientReviewReducer,
  appointment: AppoinmentReducer,
  serviceCallerReassignment: serviceCallerReassignmentReducer,
  printQR: printQRReducer,
  inwardStock: inwardStockReducer,
  stockTransaction: stockTransactionReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
